import { useCallback } from "react";
import { useToastContext } from "./Toast";
import type { ToastVariant } from "./Toast";

// ── Types ─────────────────────────────────────────────────────────────────────

interface ToastOptions {
  description?: string;
  duration?: number;
}

type ToastFn = (title: string, options?: ToastOptions) => void;

export interface UseToastReturn {
  toast: Record<ToastVariant, ToastFn>;
}

// ── Hook ──────────────────────────────────────────────────────────────────────

export function useToast(): UseToastReturn {
  const { addToast } = useToastContext();

  const make = useCallback(
    (variant: ToastVariant): ToastFn =>
      (title, options = {}) =>
        addToast({
          variant,
          title,
          description: options.description,
          duration: options.duration ?? 4000,
        }),
    [addToast],
  );

  return {
    toast: {
      success: make("success"),
      error:   make("error"),
      warning: make("warning"),
      info:    make("info"),
    },
  };
}
